// src/BusinessList.js
import React, { useEffect, useState } from "react";
import { api, API_BASE } from "./api";

export default function BusinessList({ onBack }) {
  const [businesses, setBusinesses] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const loadBusinesses = async () => {
    try {
      setBusy(true);
      const res = await api.get("/server.php/business");
      setBusinesses(Array.isArray(res.data) ? res.data : []);
      setMessage("");
    } catch (err) {
      console.error("Load business error:", err);
      setMessage("⚠️ Could not load businesses");
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    loadBusinesses();
  }, []);

  const saveBusiness = async () => {
    if (!modalData) return;

    const payload = {
      name: (modalData.name || "").trim(),
      address: (modalData.address || "").trim(),
      tax_id: (modalData.tax_id || "").trim(),
    };

    if (!payload.name) {
      setMessage("⚠️ Name is required");
      return;
    }

    try {
      setBusy(true);
      if (modalData.id) {
        await api.put(`/server.php/business/${modalData.id}`, payload);
        setMessage("✅ Business updated");
      } else {
        await api.post("/server.php/business", payload);
        setMessage("✅ Business added");
      }
      setModalData(null);
      await loadBusinesses();
    } catch (err) {
      console.error("Save business error:", err);
      setMessage("⚠️ Save failed");
    } finally {
      setBusy(false);
    }
  };

  const deleteBusiness = async (id) => {
    if (!window.confirm("Delete this business?")) return;
    try {
      setBusy(true);
      // ✅ FIX: use backticks so ${id} is interpolated
      await api.delete(`/server.php/business/${id}`);
      setMessage("✅ Business deleted");
      await loadBusinesses();
    } catch (err) {
      console.error("Delete business error:", err);
      setMessage("⚠️ Delete failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ textAlign: "center", padding: "2rem" }}>
      <h2>🏢 Business Details</h2>

      <div style={{ fontSize: 12, marginBottom: 10 }}>
        API: <code>{API_BASE}</code> {busy ? "…" : ""}
      </div>

      {message && <div style={{ marginBottom: 10 }}>{message}</div>}

      <button
        onClick={() => setModalData({ name: "", address: "", tax_id: "" })}
        style={{ marginBottom: "1rem" }}
        disabled={busy}
      >
        ➕ Add Business
      </button>

      <table style={{ margin: "0 auto", borderCollapse: "collapse", width: "80%" }}>
        <thead>
          <tr>
            <th style={thStyle}>ID</th>
            <th style={thStyle}>Name</th>
            <th style={thStyle}>Address</th>
            <th style={thStyle}>Tax ID</th>
            <th style={thStyle}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {businesses.map((biz) => (
            <tr key={biz.id}>
              <td style={tdStyle}>{biz.id}</td>
              <td style={tdStyle}>{biz.name}</td>
              <td style={tdStyle}>{biz.address}</td>
              <td style={tdStyle}>{biz.tax_id}</td>
              <td style={tdStyle}>
                <button onClick={() => setModalData(biz)} style={actionBtn} disabled={busy}>
                  ✏ Edit
                </button>
                <button onClick={() => deleteBusiness(biz.id)} style={actionBtn} disabled={busy}>
                  🗑 Delete
                </button>
              </td>
            </tr>
          ))}
          {!businesses.length && (
            <tr>
              <td style={tdStyle} colSpan={5}>
                No businesses found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <button onClick={onBack} style={{ marginTop: "2rem" }} disabled={busy}>
        🔙 Back
      </button>

      {modalData && (
        <div style={overlayStyle}>
          <div style={modalStyle}>
            <h3>{modalData.id ? "✏ Edit Business" : "➕ Add Business"}</h3>

            <input
              type="text"
              placeholder="Name"
              value={modalData.name || ""}
              onChange={(e) => setModalData({ ...modalData, name: e.target.value })}
              style={inputStyle}
            />
            <input
              type="text"
              placeholder="Address"
              value={modalData.address || ""}
              onChange={(e) => setModalData({ ...modalData, address: e.target.value })}
              style={inputStyle}
            />
            <input
              type="text"
              placeholder="Tax ID"
              value={modalData.tax_id || ""}
              onChange={(e) => setModalData({ ...modalData, tax_id: e.target.value })}
              style={inputStyle}
            />

            <div style={{ marginTop: "1rem" }}>
              <button onClick={saveBusiness} style={{ ...actionBtn, marginRight: "1rem" }} disabled={busy}>
                💾 Save
              </button>
              <button onClick={() => setModalData(null)} style={actionBtn} disabled={busy}>
                ❌ Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const thStyle = {
  border: "1px solid #ddd",
  padding: "8px",
  backgroundColor: "#007bff",
  color: "white",
};

const tdStyle = {
  border: "1px solid #ddd",
  padding: "8px",
};

const actionBtn = {
  margin: "0 5px",
  padding: "4px 8px",
  cursor: "pointer",
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const modalStyle = {
  background: "white",
  padding: "2rem",
  borderRadius: "8px",
  width: "320px",
  textAlign: "center",
};

const inputStyle = {
  width: "100%",
  marginBottom: "1rem",
  padding: "0.5rem",
};
